import { useEffect, useState } from 'react';
import tw from 'twin.macro';
import { useTranslation } from 'react-i18next';

import { negationOptions } from './SegmentCreatorItem';
import { Dropdown, IDropdownOption, Option } from '@components/Dropdown';
import {
  SegmentCreatorData,
  useSegmentCreatorContext,
} from '@insights_module/context/SegmentCreatorContext';
import { AQLQueryType } from '@insights_module/adc_ql/types';
import { useFilterTypeOptions } from '@insights_module/hooks/useFilterTypeOptions';

export const SegmentCreatorShowTypeItem = ({
  segmentData,
}: {
  segmentData: SegmentCreatorData;
}) => {
  const { value, negation } = segmentData;
  const { t } = useTranslation();
  const { pushSegmentData, isPresentational } = useSegmentCreatorContext();
  const { dropdownOptions } = useFilterTypeOptions();

  const valueOptions: IDropdownOption[] = [
    {
      value: 'episodic',
      label: <Option>{t('insights.query_builder.show_type.episodic')}</Option>,
    },
    {
      value: 'serial',
      label: <Option>{t('insights.query_builder.show_type.serial')}</Option>,
    },
    {
      value: 'episodic_serial',
      label: <Option>{t('insights.query_builder.show_type.episodic_serial')}</Option>,
    },
  ];

  const [selectedType, setSelectedType] = useState<IDropdownOption>(
    dropdownOptions.find((item) => item.value === segmentData.type) || dropdownOptions[0]
  );

  const [isNegation, setIsNegation] = useState<boolean>(negation || false);

  const [selectedShowType, setSelectedShowType] = useState<IDropdownOption>(
    valueOptions.find((item) => item.value === (value as unknown as string)) || valueOptions[0]
  );

  useEffect(() => {
    if (selectedType) {
      const type = selectedType.value as string;
      pushSegmentData({
        ...segmentData,
        type: type as AQLQueryType,
        category: null,
        value: null,
        condition: null,
        negation: false,
      });
    }
  }, [selectedType]);

  useEffect(() => {
    if (selectedShowType) {
      const segment = {
        ...segmentData,
        value: selectedShowType.value,
        negation: isNegation,
      };
      pushSegmentData(segment);
    }
  }, [selectedShowType, isNegation]);

  return (
    <div tw='flex gap-1 items-center'>
      <Dropdown
        options={dropdownOptions}
        value={selectedType}
        onChange={(val) => setSelectedType(val as IDropdownOption)}
        labelStyle={tw`bg-spec-show-type-filter-bg border border-spec-show-type-filter-stroke text-spec-show-type-filter-text font-semibold`}
        caretStyle={tw`fill-spec-show-type-filter-text`}
        dropdownMenuStyle={tw`w-[178px]`}
        isPresentational={isPresentational}
      />

      <Dropdown
        options={negationOptions}
        value={isNegation ? negationOptions[1] : negationOptions[0]}
        onChange={(val) => setIsNegation((val as IDropdownOption).value === 'is_not')}
        isPresentational={isPresentational}
      />

      <Dropdown
        options={valueOptions}
        value={selectedShowType}
        onChange={(val) => setSelectedShowType(val as IDropdownOption)}
        isPresentational={isPresentational}
      />
    </div>
  );
};
